/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-07-09 15:39:19
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-11 18:37:03
 */

import { useEffect, useState } from "react";
import { Divider, Modal, message, Space } from "antd";
import { useTranslation, Trans } from "react-i18next";
import { fetchDownGrade } from "@/api/modules/plan";
import "./index.less";
import { BlueText } from "@/language/component";

const DegradationModal = ({ open, onCancel }) => {
	const { t } = useTranslation();
	const [downgradeStep, setDowngradeStep] = useState<number>(1);
	const [downgradeFailedInfoList, setDowngradeFailedInfoList] = useState<string[]>([]);

	useEffect(() => {
		setDowngradeStep(1);
	}, [open]);
	const handleDowngrade = () => {
		fetchDownGrade().then(res => {
			if (res.downgradeStatus === "success") {
				message.success(t("message.success"));
				onCancel();
			} else {
				const fieldInfoList = [];
				if (res.connectedAdAccountsLimit) {
					fieldInfoList.push(
						<Trans
							i18nKey="billing.degradation.confirm.tips.list1"
							components={{ important: <BlueText /> }}
							values={{ count: 30 }}
						/>
					);
				}
				if (res.ruleCreationLimit) {
					fieldInfoList.push(
						<Trans
							i18nKey="billing.degradation.confirm.tips.list2"
							components={{ important: <BlueText /> }}
							values={{ count: 20 }}
						/>
					);
				}
				if (res.ruleActivationLimit) {
					fieldInfoList.push(
						<Trans
							i18nKey="billing.degradation.confirm.tips.list3"
							components={{ important: <BlueText /> }}
							values={{ count: 20 }}
						/>
					);
				}
				if (res.teamSizeLimit) {
					fieldInfoList.push(
						<Trans
							i18nKey="billing.degradation.confirm.tips.list5"
							components={{ important: <BlueText /> }}
							values={{ count: 20 }}
						/>
					);
				}
				setDowngradeFailedInfoList(fieldInfoList);
				setDowngradeStep(2);
			}
		});
	};

	const DegradationConditionList = () => {
		return (
			<Modal
				title={t("billing.degradation.confirm")}
				onOk={() => {
					handleDowngrade();
				}}
				okText={t("action.button.confirm")}
				closable
				open={open}
				onCancel={onCancel}
			>
				<Divider />

				<div className="degradationCondition">
					<p>
						<Trans
							i18nKey="billing.degradation.confirm.tips"
							components={{ important: <BlueText /> }}
							values={{ Plan: t("billing.plan.name.professional") }}
						/>
					</p>
				</div>
				<ul className="degradationConditionList">
					<li>
						<Trans
							i18nKey="billing.degradation.confirm.tips.list1"
							components={{ important: <BlueText /> }}
							values={{ count: 30 }}
						/>
					</li>
					<li>
						<Trans
							i18nKey="billing.degradation.confirm.tips.list2"
							components={{ important: <BlueText /> }}
							values={{ count: 20 }}
						/>
					</li>
					<li>
						<Trans
							i18nKey="billing.degradation.confirm.tips.list3"
							components={{ important: <BlueText /> }}
							values={{ count: 20 }}
						/>
					</li>
					<li>
						<Trans
							i18nKey="billing.degradation.confirm.tips.list4"
							components={{ important: <BlueText /> }}
							values={{ count: 20 }}
						/>
					</li>
					<li>
						<Trans
							i18nKey="billing.degradation.confirm.tips.list5"
							components={{ important: <BlueText /> }}
							values={{ count: 20 }}
						/>
					</li>
				</ul>
			</Modal>
		);
	};
	const DegradationFailedInfo = () => {
		return (
			<Modal title={t("billing.degradation.modal.failed.tip")} closable onCancel={onCancel} open={open} onOk={onCancel}>
				<div style={{ display: "flex", flexDirection: "column" }}>
					<span>{t("billing.degradation.modal.failed.content.before")}</span>
					<Space direction="vertical" style={{ marginLeft: 40 }}>
						{downgradeFailedInfoList.map((item, index) => {
							return <span key={index}>{item}</span>;
						})}
					</Space>
					<span style={{ marginLeft: 0 }}>{t("billing.degradation.modal.failed.content.after")}</span>
				</div>
			</Modal>
		);
	};

	if (downgradeStep === 1) {
		return DegradationConditionList();
	}

	if (downgradeStep === 2) {
		return DegradationFailedInfo();
	}
};

export default DegradationModal;
